import * as types from "@/store/types";
import axios from "axios";

export default {
  saveToken({ commit }, token) {
    commit(types.SAVE_TOKEN, token);
  },
  async getControlStatus({ commit }, name) {
    try {
      const  data  = await axios.get(`/api/web/control/${name}`);

      return data;
    } catch (e) {
      return null;
    }
  },
};
